import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private breadcrumb = new BehaviorSubject([]);
  public sharedBreadcrumb = this.breadcrumb.asObservable();
  private customerId: number;
  private advertiserId: number;
  private brandId: number;

  constructor(
    private router: Router,
    private campaignAdapter: CampaignAdapter
  ) { }

  private breadcrumbCommonProps = {
    dropdownEnabled: true,
    dropdownSearchable: true,
    dropdownDarkThemed: false,
    dropdownInfiniteScroll: 'client',
    dropdownMinWidth: 500,
    dropdownMaxResultRows: 10
  };

  prepareBreadcrumb(customerId?: number, advertiserId?: number, brandId?: number) {
    let customerData = [];
    if (customerId && advertiserId && brandId) {
      customerData.push(this.getCustomerData(customerId), this.getAdvertiserData(advertiserId, customerId), this.getBrandData(brandId, advertiserId, customerId));
    } else if (customerId && advertiserId) {
      customerData.push(this.getCustomerData(customerId), this.getAdvertiserData(advertiserId, customerId));
    } else if (customerId) {
      customerData.push(this.getCustomerData(customerId));
    } else {
      this.breadcrumb.next([]);
    }
    if (customerData.length) {
      Promise.all(customerData).then((values) => {
        this.breadcrumb.next(values);
      });
    }
  }

  async getCustomerData(customerId: number) {
    let customerData = Object.assign({
      title: '',
      label: 'COMPANY',
      onClick: this.handleOnCustomerSelectRef,
      dropdownItems: []
    }, this.breadcrumbCommonProps);
    this.customerId = customerId;

    let customers = await this.campaignAdapter.getCustomers().then(
      (response: any[]) => {
        return response;
      }
    );
    let custKey: number, custName: string;
    for (let i = 0; i < customers.length; i++) {
      custName = customers[i].Name;
      custKey = customers[i].Id;
      if (custKey == customerId) {
        customerData.title = custName;
      }
      customerData.dropdownItems.push({
        label: custName,
        customerId: custKey,
        onClick: this.handleOnCustomerSelectRef
      });
    }
    // Add all companies option
    customerData.dropdownItems.unshift({
      label: 'All Companies',
      customerId: -1,
      onClick: this.handleOnCustomerSelectRef
    });

    return customerData;
  }

  async getAdvertiserData(advertiserId: number, customerId: number) {
    let advertiserData = Object.assign({
      title: '',
      label: 'Advertiser',
      onClick: this.handleOnAdvertiserSelectRef,
      dropdownItems: [],
    }, this.breadcrumbCommonProps);

    this.customerId = customerId;
    this.advertiserId = advertiserId;

    let advertiser = await this.campaignAdapter.getAdvertiserIds(customerId).then(
      (response: any[]) => {
        return response;
      }
    );
    let advKey: number,
      advName: string;
    for (let i = 0; i < advertiser.length; i++) {
      advKey = advertiser[i].Id;
      advName = advertiser[i].Name;
      if (advKey == advertiserId) {
        advertiserData.title = advName;
      }
      advertiserData.dropdownItems.push({
        label: advName,
        customerId: customerId,
        advertiserId: advKey,
        onClick: this.handleOnAdvertiserSelectRef
      });
    }

    // Add all advdrtisers option
    advertiserData.dropdownItems.unshift({
      label: 'All Advertisers',
      customerId: customerId,
      advertiserId: -1,
      onClick: this.handleOnAdvertiserSelectRef
    });

    return advertiserData;
  }

  async getBrandData(brandId: number, advertiserId: number, customerId: number) {
    let brandData = Object.assign({
      title: '',
      label: 'Brand',
      onClick: this.handleOnBrandSelectRef,
      dropdownItems: [],
    }, this.breadcrumbCommonProps);

    this.customerId = customerId;
    this.advertiserId = advertiserId;
    this.brandId = brandId;

    let brands = await this.campaignAdapter.getBrandIds(customerId, advertiserId).then(
      (response: any[]) => {
        return response;
      }
    );
    let brandKey: number,
      brandName: string;
    for (let i = 0; i < brands.length; i++) {
      brandKey = brands[i].Id;
      brandName = brands[i].Name;
      if (brandKey == brandId) {
        brandData.title = brandName;
      }
      brandData.dropdownItems.push({
        label: brandName,
        customerId: customerId,
        advertiserId: advertiserId,
        brandId: brandKey,
        onClick: this.handleOnBrandSelectRef
      });
    }
    return brandData;
  }

  handleOnCustomerSelectRef = this.handleOnCustomerSelect.bind(this);
  handleOnAdvertiserSelectRef = this.handleOnAdvertiserSelect.bind(this);
  handleOnBrandSelectRef = this.handleOnBrandSelect.bind(this);

  handleOnCustomerSelect(item: any) {
    this.handleBreadcrumbRoute(item.props && item.props.customerId || this.customerId);
  }

  handleOnAdvertiserSelect(item: any) {
    this.handleBreadcrumbRoute(item.props && item.props.customerId || this.customerId, item.props && item.props.advertiserId || this.advertiserId);
  }

  handleOnBrandSelect(item: any) {
    this.handleBreadcrumbRoute(item.props && item.props.customerId || this.customerId, item.props && item.props.advertiserId || this.advertiserId, item.props && item.props.brandId || this.brandId);
  }

  handleBreadcrumbRoute(customerId: number, advertiserId?: number, brandId?: number) {
    if (customerId && advertiserId && brandId) {
      this.campaignAdapter.updateCBAId(customerId, advertiserId, brandId);
      this.router.navigate(['campaign/list']);
    } else if (customerId && advertiserId) {
      this.campaignAdapter.updateCBAId(customerId, advertiserId, null);
      if (advertiserId > 0) {
        this.router.navigate(['advertiser/campaign-list']);
      } else {
        this.router.navigate(['advertiser/brand-list']);
      }
    } else if (customerId) {
      this.campaignAdapter.updateCBAId(customerId, null, null);
      if (customerId > 0) {
        this.router.navigate(['company/advertiser-list']);
      } else {
        this.router.navigate(['company/list']);
      }
    }
  }

}
